import React, { Component } from "react";
import ReactTooltip from "react-tooltip";

export default class Hover extends Component {
  constructor(props) {
    super(props);
    this.state = {
      place: "top",
      type: "dark",
      effect: "float",
      condition: false,
    };
  }

  changePlace(place) {
    this.setState({
      place: place,
    });
  }

  changeType(type) {
    this.setState({
      type: type,
    });
  }

  changeEffect(effect) {
    this.setState({
      effect: effect,
    });
  }

  _onClick() {
    this.setState({
      condition: true,
    });
  }

  render() {
    const { place, type, effect } = this.state;
    return (
      <div>
        <section className="tooltip-example">
          <h4 className="title">React Tooltip</h4>
          <div className="demonstration">
            <p
              data-for="main"
              data-tip="Hello<br />multiline<br />tooltip"
              data-iscapture="true"
            >
              ◕‿‿◕
            </p>
          </div>

          <ReactTooltip
            id="main"
            place={place}
            type={type}
            effect={effect}
            multiline={true}
          />
        </section>
      </div>
    );
  }
}
